export default "__VITE_ASSET__BzcF5fRG__"